import React from 'react';
import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import { SpheraSpinner } from "@sphera-cloud/component-ui-reactjs";

export function DeleteUserModal(props) {
    const loadingPanel = (
        <div className="k-loading-mask">
            <span className="k-loading-text">{props.localizations.Loading}</span>
            <SpheraSpinner version={1} color="dark-1" />
        </div>
    );

    return (
        <div>
            {props.showDeleteUserModal && (
                <SpheraModal className="DeleteFilterModal" title={props.localizations.Delete} width={400} height={300}
                    onClose={props.toggleDeleteUserModal}
                    onCancel={props.toggleDeleteUserModal}
                    cancelText={props.localizations.Cancel}
                    actionText={props.localizations.Delete}
                    onAction={props.submitDeleteUser}
                >
                    <div className="DeleteUserModalDiv" >
                        <div>{props.localizations.DeleteUserConfirm}</div>
                        {props.modalPending && loadingPanel}
                    </div>
                </SpheraModal>
            )}
        </div>
    );
}